import {createReducer} from 'store/config/creators';
import {TAction} from 'store/config/types';

import {CONTEXT_ACTIONS} from './context-constants';
import {
    TContextSetLookupsPayload,
    TContextSetRawDataPayload,
    IContextState,
} from './context-types';

const initialState = {
    fetchedWithContext: [],
};

export const contextReducer = createReducer(initialState, {
    [CONTEXT_ACTIONS.SET_CONTEXT_LOOKUPS]: (
        state: IContextState,
        {payload}: TAction<TContextSetLookupsPayload>,
    ) => ({
        ...state,
        lookups: payload,
    }),
    [CONTEXT_ACTIONS.SET_CONTEXT_RAW_DATA]: (
        state: IContextState,
        {payload}: TAction<TContextSetRawDataPayload>,
    ) => ({
        ...state,
        rawData: payload.rawData,
    }),
    [CONTEXT_ACTIONS.UPDATE_CONTEXT_RAW_DATA]: (
        state: IContextState,
        {payload}: TAction<TContextSetRawDataPayload>,
    ) => ({
        ...state,
        rawData: {
            ...state.rawData,
            ...payload.rawData,
        },
    }),
    [CONTEXT_ACTIONS.RESET_CONTEXT]: (
        state: IContextState,
    ) => ({
        ...state,
        rawData: undefined,
    }),
    [CONTEXT_ACTIONS.ADD_TO_FETCHED_WITH_CONTEXT]: (
        state: IContextState,
        {payload}: TAction<string>,
    ) => {
        const currentFetchedWithContextList = [...state.fetchedWithContext];
        if (!currentFetchedWithContextList.includes(payload)) { currentFetchedWithContextList.push(payload); }
        return {
            ...state,
            fetchedWithContext: currentFetchedWithContextList,
        };
    },
    [CONTEXT_ACTIONS.SET_FETCHED_WITH_CONTEXT]: (
        state: IContextState,
        {payload}: TAction<string[]>,
    ) => ({
        ...state,
        fetchedWithContext: payload,
    }),
});
